import {Component, Input} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";
import {RequireClaimsDirective} from "../../../auth/components/require-claims.directive";
import {RouterLink} from "@angular/router";
import {NgClassType} from "../../../model/common.model";

@Component({
  selector: 'user-id-tag',
  standalone: true,
  imports: [
    NgIf,
    RequireClaimsDirective,
    RouterLink,
    NgClass,
  ],
  templateUrl: './user-id-tag.component.html'
})
export class UserIdTagComponent {
  @Input() userId?: string
  @Input() ngClass?: NgClassType
  checkFailed = false
}
